import React, { useContext, useEffect, useState } from 'react';
import LoginArrowSvg from '../svg/LoginArrowSvg';
import loginImgLrg from '../images/loginImgLrg.png';
// import logoLrg from '../images/logoLrg.png';
import HamburgerSvg from '../svg/HamburgerSvg';
// import { publicFetch } from './../util/fetch';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { DataContext } from '../context/DataContext';
import { useHistory } from 'react-router-dom';
import { toTitleCase } from '../util/titleCase';
import { animated, useSpring } from 'react-spring';
import LoadingModal from '../components/common/LoadingModal';
import NtwrkErrMsg from '../components/common/NtwrkErrMsg';

const PreLogin = () => {
  // window.location.assign('https://demo.edves.net/login/students');
  // let schoolDomain = window.location.host;
  // localStorage.removeItem('studentInfo')

  const authContext = useContext(AuthContext);
  const dataContext = useContext(DataContext);
  const history = useHistory();

  const [subSchoolData, setSubSchoolData] = useState([]);
  const [defaultSchoolData, setDefaultSchoolData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [fetchError, setFetchError] = useState('');

  const storeSchoolData = () => {
    const schoolUrl = window.location.host;

    let checkIfLocal =
      schoolUrl.includes('localhost') || schoolUrl === '127.0.0.1:5173';
    let schoolDomain = 'nill';
    if (checkIfLocal) {
      // schoolDomain = "s-teeschool.edves.net"
      // Adm. No: STEE/20/JSS1/066
      // Pass: QTCEZZ
      schoolDomain = 'demo.edves.net';
      // schoolDomain = "dijs.edves.net"
    } else {
      schoolDomain = schoolUrl;
    }

    localStorage.setItem('schoolInfo', JSON.stringify(defaultSchoolData));
    localStorage.setItem('schoolDomain', schoolDomain);

    return { schoolDomain };
  };
  //storeSchoolData();

  useEffect(() => {
    const enterSubSchool = async () => {
      try {
        setShowModal(true);
        const { data } = await axios.get(
          `${authContext.baseUrl}/getsubschools/${
            storeSchoolData().schoolDomain
          }`
        );
        if (data.status) {
          setShowModal(false);
          const school = data.data;

          setSubSchoolData(school.schoolDivisions);
          setDefaultSchoolData(school.schoolDetails);
          dataContext.setDefaultSchoolData(storeSchoolData().schoolDomain);
          // document.title = (`Edves - ${toTitleCase(school.schoolDetails.defaultSchoolName)}`);
          // console.log(document.title)
        }
      } catch (error) {
        // console.log(error);
        setShowModal(false);
        window.navigator.onLine
          ? setFetchError('Check Internet Connectivity')
          : setFetchError('Oops! Something Went Wrong');
      }
    };
    enterSubSchool();
    return () => {};
  }, []);

  // useEffect(() => {
  //     console.log(subSchoolData);
  // });

  const subSchoolLogIn = (school) => {
    // console.log(school.deploymentIdx)
    console.log(school, 'tomzy check');
    const schoolLoginCredentials = {
      deploymentIdx: school.idx,
      SchoolUrl: storeSchoolData().schoolDomain,
      schoolName: school.name,
    };
    authContext.setSchoolInfo(schoolLoginCredentials);
    localStorage.setItem('subSchoolData', JSON.stringify(school));
    history.push('login');
  };

  const transitionStyles = useSpring({
    to: [{ transform: 'translateY(0px)' }],
    from: { transform: 'translateY(-100px)' },
    config: { duration: 500 },
  });

  return (
    <>
      {/* { (schoolDomain.includes('localhost') || schoolDomain === 'demo.edves.net') && window.location.assign('https://demo.edves.net/login/students')} */}
      {showModal && <LoadingModal />}
      {
        <animated.div
          style={transitionStyles}
          className='bg-gray-700 w-full h-screen'
        >
          <nav className='bg-white h-16 px-4 items-center flex justify-between'>
            <div className='sm:hidden'>
              <HamburgerSvg />
            </div>
            <img
              src={defaultSchoolData.defaultSchoolloogo}
              alt='logo'
              className='w-10 object-cover'
            />
            <span className='hidden sm:block sm:mx-auto text-gray-200 font-semibold text-sm leading-5'>
              {' '}
              {toTitleCase(defaultSchoolData.defaultSchoolName)} Parent Portal{' '}
            </span>
          </nav>
          <div clasName='sm:w-full px-8 sm:p-0'>
            <div className='bg-blue-100 flex justify-between w-11/12 sm:w-2/3 rounded-lg mt-12 mx-auto px-6 py-4 items-center shadow-lg'>
              <div className=''>
                <span className='text-xs sm:text-xl text-white leading-6 mt-1'>
                  {' '}
                  Log in to{' '}
                </span>
                <p className='text-sm sm:text-base text-white font-bold leading-6 mt-1'>
                  {' '}
                  {toTitleCase(defaultSchoolData.defaultSchoolName)} Parent
                  Portal{' '}
                </p>
              </div>
              <img src={loginImgLrg} alt='login illustration' />
            </div>
          </div>
          {fetchError && (
            <div className='mt-8 mx-auto w-64'>
              <NtwrkErrMsg errMsg={fetchError} showReload={true} />
            </div>
          )}
          {subSchoolData &&
            subSchoolData.map((school) => {
              return (
                <>
                  <div
                    onClick={() => subSchoolLogIn(school)}
                    className='bg-white mySubSch flex justify-between w-11/12 sm:w-2/3 rounded-lg mt-8 mx-auto px-6 py-4 items-center shadow-xl hover:shadow-2xl cursor-pointer'
                  >
                    <div className=''>
                      <span className='text-sm sm:text-xl text-gray-200 leading-6 font-bold'>
                        {' '}
                        {toTitleCase(school.name)}{' '}
                      </span>
                      <p className='mt-1 text-xs sm:text-sm'>
                        {' '}
                        {school.schooltype}{' '}
                      </p>
                      <div className='flex items-center'>
                        <p className='text-blue-100 hover:text-white text-sm mt-1'>
                          {' '}
                          Log in{' '}
                        </p>
                        <span className='ml-4 mt-2'>
                          <LoginArrowSvg />
                        </span>
                      </div>
                    </div>
                    <div className='flex-shrink-0'>
                      <img
                        src={school.school_logo}
                        alt='logo'
                        className='rounded-full largeLogoSize object-cover'
                      />
                    </div>
                  </div>
                </>
              );
            })}
        </animated.div>
      }
    </>
  );
};

export default PreLogin;
